<template>
  <div>
    <a-row :style="{ color: backgroundColor }">
      <a-col class="breadcrumb" style="padding: 19px 0">
        <a-breadcrumb>
          <template #separator>
            <span style="color: #bbbbbb">></span>
          </template>
          <a-breadcrumb-item v-for="(item, index) in breadcrumbData" :key="index">
            <a v-if="item.clickable && item.path === '/'" :href="homePageUrl">
              {{ $t(item.name) }}
            </a>
            <router-link v-else-if="item.clickable" :to="item.path">
              {{ $t(item.name) }}
            </router-link>
            <span v-else>
              {{ $t(item.name) }}
            </span>
          </a-breadcrumb-item>
          <a-breadcrumb-item v-if="breadcrumbData.length && breadcrumbLastName">
            {{ breadcrumbLastName }}
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import { breadcrumbsJson, detailJson } from '@/const/breadcrumb';
export default {
  name: 'BaseBreadcrumb',
  props: {
    backgroundColor: {
      type: String,
      default: '#fff',
    },
  },
  data() {
    return {
      breadcrumbData: [],
    };
  },
  computed: {
    ...mapState({
      supplyChainInfo: (state) => state.supplyChainInfo,
    }),
    homePageUrl() {
      return process.env.RELEASE === 'stable' ? 'https://www.yzdli.com' : 'http://beta.yunhzh.com';
    },
    breadcrumbLastName() {
      // console.log('插入的面包屑数据', this.$store.state.breadcrumbLastName)
      return this.$store.state.breadcrumbLastName;
    },
  },
  watch: {
    $route() {
      console.log('watch:Breadcrumb');
      this.$store.commit('setBreadcrumbLastName', '');
      this.setRoutes();
    },
  },
  mounted() {
    // this.$store.commit('setBreadcrumbLastName', '')
    this.setRoutes();
  },
  methods: {
    setRoutes() {
      console.log('setRoutes', this.$route);
      this.$route.matched.forEach((item, index) => {
        // console.log(item)
        const data = this.matchBreadcrumbData(this.$route.fullPath);
        // console.log('生成路由数据', data)
        // 返回的面包屑路由第一个是会员中心时,在前面添加官网的路由
        // if(data.length != 0 && data[0].name === "会员中心"){

        // 如果有供应链信息，第一项显示"采购系统"，否则显示官网
        if (this.supplyChainInfo?.unicode) {
          data.unshift({
            name: '采购系统',
            path: `/supply?toSupplyId=${this.supplyChainInfo.unicode}`,
            clickable: true,
            isShow: true,
          });
        } else {
          data.unshift(breadcrumbsJson.find((bread) => bread.path === '/'));
        }

        this.breadcrumbData = data;
        console.log('this.breadcrumbData', this.breadcrumbData);
      });
    },
    path2Arr(path) {
      // console.log(path)
      // console.log(path.split('/').filter((p) => p))
      return path.split('/').filter((p) => p);
    },
    matchBreadcrumbData(matchPath) {
      /**
       * 判断是否裁剪掉后面的参数
       * 1.默认返回裁剪掉参数的url
       * 2.有不需要过滤的参数字段时,返回不裁剪的url
       * TODO后面要优化,不应该使用string来判断
       */
      const croppath = (path) => {
        const pathSplit = path.split('?');
        const notFilter = ['applyType', 'applyIdentityType'];
        let paths = pathSplit[0];
        // console.log('paths', pathSplit, pathSplit[0], pathSplit[1])
        if (pathSplit[1]) {
          for (const item of notFilter) {
            // console.log('item', item)
            if (pathSplit[1].includes(item)) {
              // console.log('paths = path', path)
              paths = path;
              break;
            }
          }
        }
        return paths;
      };
      return (
        this.path2Arr(matchPath)
          .map((path) => {
            let val = path;
            val = croppath(path).replace(/^:([^:?]+)(\?)?$/, (match, $1) => {
              return `_${$1}`;
            });
            return `/${val}`;
          })
          .map((path, index, paths) => {
            // 第 0 个不需拼接
            if (index) {
              let result = '';
              for (let i = 0; i <= index; i++) {
                // console.log('1', paths[i])
                result += paths[i];
              }
              // console.log('1.1', result)
              return result;
            }
            return path;
          })
          // 如果在JSON中找不到,就生产一条新的
          .map((path, index) => {
            // console.log('1.9', path, index)
            const item = breadcrumbsJson.find((bread) => bread.path === path);
            // console.log('2', path, item)
            if (item) {
              return item;
            }
            return {
              name: path.split('/').pop(),
              path,
              clickable: false,
              isShow: true,
              isNew: true,
            };
          })
          // 过滤掉详情的
          .filter((item, index) => {
            return detailJson.find((bread) => {
              if (item.isNew) {
                return bread.path.includes(item.path);
              }
              return true;
            });
          })
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  ::v-deep .ant-breadcrumb-separator,
  ::v-deep .ant-breadcrumb-separator a {
    color: #bbbbbb;
  }
}
</style>
